import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

type LabelBoxProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

export const LabelBox = ({ children, sx }: LabelBoxProps) => (
  <Box
    sx={{
      paddingBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      ...sx,
    }}
  >
    {children}
  </Box>
);
